import { __extends } from "tslib";
import React from 'react';
import { window, utils } from 'pro-gallery-lib';
import { GalleryComponent } from '../../galleryComponent';
var GalleryDebugMessage = /** @class */ (function (_super) {
    __extends(GalleryDebugMessage, _super);
    function GalleryDebugMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GalleryDebugMessage.prototype.render = function () {
        if (utils.getTopUrlParam('pgdebug') !== 'true') {
            return false;
        }
        var version = (React.createElement("div", { className: "version-header " },
            "Pro Gallery Version #",
            window.staticsVersion));
        var parentSize = '';
        try {
            parentSize =
                ' psw' +
                    window.top.screen.width +
                    ' piw' +
                    window.top.innerWidth +
                    ' pbw' +
                    window.top.document.body.clientWidth;
        }
        catch (e) {
            //not on the domain
        }
        var debugMsg = (React.createElement("div", { className: "version-header " },
            utils.isLandscape() ? 'land' : 'port',
            " sw",
            window.screen.width,
            "sh",
            window.screen.height,
            " iw",
            window.innerWidth,
            " bw",
            window.document.body.clientWidth,
            " sr",
            '1',
            "rc",
            this.props.resizeCount,
            " oc",
            this.props.orientationCount,
            " nh",
            this.props.newHeight,
            " lh",
            this.props.lastHeight,
            parentSize,
            "www",
            this.props.maxGalleryWidth));
        return (React.createElement("div", null,
            version,
            debugMsg));
    };
    return GalleryDebugMessage;
}(GalleryComponent));
export default GalleryDebugMessage;
//# sourceMappingURL=galleryDebugMessage.js.map